<script>
import useTools from "@/use/Tools";
import {onMounted, ref} from "vue";
import PrivilegeAction from "./Components/PrivilegeAction.vue";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    props: {
        updateAction: Boolean,
        viewAction: Boolean,
    },
    components: {PrivilegeAction},
    setup() {
        const securityStore = useSecurityStore();
        const {$route} = useTools();
        const {getBack} = useSharedMethod();

        const role = ref({});
        const modules = ref([]);
        const actions = ref([]);

        function findRoleById() {
            axios.get(`/roles/${$route.params.roleId}`).then(response => {
                role.value = response.data;
            });
        }

        function findAllModule() {
            axios.get(`/privilegeModules`).then(response => {
                modules.value = response.data;
            });
        }

        function findCommonActions() {
            axios.get(`/privilegeModules/commonActions`).then(response => {
                actions.value = response.data;
            });
        }

        function getAffectation(moduleId, actionId) {
            let m = modules.value.find(e => e.id === moduleId);
            if (m)
                return m.affectations.find(a => a.actionId === actionId);
            return null;
        }

        function getPrivilege(moduleId, actionId) {
            let id = getId(moduleId, actionId);
            return privileges.value.find(p => p.id === id);
        }

        function addPrivilege(moduleId, actionId) {
            let ma = getAffectation(moduleId, actionId);
            let id = getId(moduleId, actionId);
            privileges.value.push({
                id: id,
                roleId: $route.params.roleId,
                affectationActionId: actionId,
                affectationModuleId: moduleId,
                affectationId: ma.id,
                affectationByLevel: ma.byLevel,
                level: 'ALL',
                dataAccess: 1,
                organizationalChartIds: [],
                organizationalChartNames: []
            });

        }

        function deletePrivilege(moduleId, actionId) {
            let id = getId(moduleId, actionId);
            let index = privileges.value.findIndex(p => p.id === id);
            if (index !== -1)
                privileges.value.splice(index, 1);
        }

        function getId(moduleId, actionId) {
            return Number(`${$route.params.roleId}${moduleId}${actionId}`);
        }

        function isByLevel(module) {
            return privileges.value.some(obj => obj.affectationByLevel === true && obj.affectationModuleId === module.id);
        }

        function getDataAccess(module) {
            return privileges.value.find(obj => obj.affectationByLevel === true && obj.affectationModuleId === module.id).dataAccess;
        }

        const privilege = ref({});
        const privilegeDialog = ref(false);

        function setPrivilege(moduleId, actionId) {
            privilege.value = getPrivilege(moduleId, actionId);
            privilegeDialog.value = true;
        }

        const privileges = ref([]);
        const dialog = ref(true);
        const loading = ref(false);

        function findAll() {
            loading.value = true;
            axios.get(`/privileges`, {
                params: {
                    roleId: $route.params.roleId
                }
            }).then(response => {
                privileges.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function saveAll() {
            loading.value = true;
            axios.post(`/privileges/${$route.params.roleId}`, privileges.value).then(response => {
                privileges.value = response.data;
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        const dataAccess = ref(null);

        function setDataAccess(module) {
            if (dataAccess.value) {
                privileges.value.forEach(e => {
                    if (e.affectationModuleId === module.id)
                        e.dataAccess = dataAccess.value;
                })
                dataAccess.value = null;
            }
        }

        onMounted(() => {
            findRoleById();
            findAllModule();
            findCommonActions();
            findAll();
        });

        return {
            role,
            modules,
            actions,
            privileges,
            privilege,
            privilegeDialog,
            dialog,
            loading,
            dataAccess,
            securityStore,
            getAffectation,
            getPrivilege,
            addPrivilege,
            deletePrivilege,
            setPrivilege,
            isByLevel,
            getDataAccess,
            setDataAccess,
            saveAll,
            getBack,
        }
    }
}
</script>


<template>
    <div>
        <v-dialog
            v-model="privilegeDialog"
            max-width="600"
            persistent
        >
            <v-card>
                <v-toolbar flat dense color="orange">
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="privilege.level"
                                    :items="[
                                        {id: 'ALL', name: $t('privilege.level.ALL')},
                                        {id: 'GROUP', name: $t('privilege.level.GROUP')},
                                        {id: 'OWNER', name: $t('privilege.level.OWNER')}
                                    ]"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="12" v-show="privilege.level === 'GROUP'">
                                <organizational-chart-select
                                    v-model="privilege.organizationalChartIds"
                                    :label="$t('module.organizational_chart')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        depressed
                        class="white--text"
                        color="orange"
                        @click="privilegeDialog = false"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="1500"
        >
            <v-card>
                <w-dialog-toolbar
                    update-action
                />
                <v-simple-table
                    dense
                    fixed-header
                    height="600"
                >
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left" style="width: 350px;">
                                <strong>{{ role.name }}</strong>
                            </th>
                            <th class="text-left"
                                v-for="(a, index) in actions"
                                :key="`a-${index}`"
                                style="background-color: #90caf9"
                            >
                                <strong>
                                    {{ $t(`privilege.action.${a.name}`) }}
                                </strong>
                            </th>
                            <th
                                class="text-left"
                                style="background-color: #B2EBF2; width: 130px"
                            >
                                <strong>{{ $t('privilege.data_access') }}</strong>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(m, index) in modules">
                            <tr :key="`m-${index}`">
                                <td
                                    style="background-color: #B2DFDB; width: 350px;"
                                >
                                    <strong>
                                        <v-btn
                                            v-if="m.specificAffectations.length > 0 && !m.expanded"
                                            icon
                                            @click="m.expanded = true"
                                        >
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="m.specificAffectations.length > 0 && m.expanded"
                                            icon
                                            @click="m.expanded = false"
                                        >
                                            <v-icon>mdi-chevron-up</v-icon>
                                        </v-btn>
                                        {{ $t(`privilege.module.${m.name}`) }}
                                    </strong>
                                </td>
                                <template v-for="(a, index) in actions">
                                    <td
                                        v-if="getAffectation(m.id, a.id)"
                                        :key="`ma-${index}`"
                                        style="border-right: 1px solid #E0E0E0"
                                    >
                                        <PrivilegeAction
                                            :privilege="getPrivilege(m.id, a.id)"
                                            :edit-mode="updateAction"
                                            @cogClick="setPrivilege(m.id, a.id)"
                                            @trashCanClick="deletePrivilege(m.id, a.id)"
                                            @checkboxClick="addPrivilege(m.id, a.id)"
                                        />
                                    </td>
                                    <td
                                        v-else
                                        :key="`ema-${index}`"
                                        class="disabled-td"
                                    ></td>
                                </template>

                                <td v-if="isByLevel(m)">
                                    <v-edit-dialog
                                        v-if="updateAction"
                                        :return-value.sync="dataAccess"
                                        large
                                        persistent
                                        @open="dataAccess = getDataAccess(m)"
                                        @save="setDataAccess(m)"
                                    >
                                        <v-chip
                                            small
                                            label
                                            outlined
                                            color="deep-orange"
                                            style="cursor: pointer"
                                        >
                                            <strong>{{ getDataAccess(m) }}</strong>
                                        </v-chip>
                                        <template v-slot:input>
                                            <div class="mt-4 text-h6">
                                                {{ $t('privilege.data_access') }}
                                            </div>
                                            <v-text-field
                                                v-model="dataAccess"
                                                label="Edit"
                                                type="number"
                                                single-line
                                                counter
                                                autofocus
                                            ></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                    <v-chip
                                        v-else
                                        small
                                        label
                                        outlined
                                        color="blue"
                                    >
                                        <strong>{{ getDataAccess(m) }}</strong>
                                    </v-chip>
                                </td>
                                <td class="disabled-td" v-else></td>
                            </tr>
                            <tr
                                v-if="m.specificAffectations.length > 0 && m.expanded"
                                :key="`extra-${index}`"
                            >
                                <td
                                    style="background-color: #B2DFDB; width: 350px;"
                                ></td>
                                <td :colspan="actions.length + 1" style="background-color: #EEEEEE">
                                    <v-container fluid>
                                        <v-simple-table dense class="elevation-10">
                                            <template v-slot:default>
                                                <tbody>
                                                <tr
                                                    v-for="(item, index) in m.specificAffectations"
                                                    :key="`spec-${index}`"
                                                >
                                                    <td>
                                                        <strong>{{ $t(`privilege.action.${item.actionName}`) }}</strong>
                                                    </td>
                                                    <td>
                                                        <PrivilegeAction
                                                            :privilege="getPrivilege(item.moduleId, item.actionId)"
                                                            :edit-mode="updateAction"
                                                            @cogClick="setPrivilege(item.moduleId, item.actionId)"
                                                            @trashCanClick="deletePrivilege(item.moduleId, item.actionId)"
                                                            @checkboxClick="addPrivilege(item.moduleId, item.actionId)"
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-container>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-update
                        :show="updateAction"
                        :loading="loading"
                        @press="saveAll"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--<v-container fluid>
            <v-card flat elevation="5">
                <v-toolbar class="elevation-5 mb-2" flat color="white" dense height="40">
                    <v-toolbar-title class="title">
                        <span>{{ $t('module.privilege') }}</span>

                    </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <div class="flex-grow-1"></div>



                </v-toolbar>
                <v-divider/>
            </v-card>
        </v-container>-->
    </div>
</template>

<style scoped>
td {
    border-right: 1px solid #E0E0E0;
}

.disabled-td {
    background-color: #CFD8DC;
}
</style>